module.exports = __webpack_public_path__ + "img/Presidente.e0c78f0e.png";